if ( !customElements.get( "newsletter-form" ) )
{
	class NewsletterForm extends HTMLFormElement {
		constructor() {
			super();

			this.selectors = {
				subscribedMessage: '[id*=Newsletter-error-subscribed]',
				modal: '[id*=NewsletterAlertModal-]',
			};

			this.init();
		}

		/**
		 * Show message when user re-subscribe with exists email.
		 */
		init() {
			const liveUrl = window.location.href;
			const result = liveUrl.includes('form_type=customer');
			const inputVal = this.querySelector('[id*="NewsletterForm"]').value.length;
			const modalEl = this.querySelector(this.selectors.modal);

			if (result && inputVal != 0) {
				const messageElement = this.querySelector(this.selectors.subscribedMessage);
				messageElement && messageElement.classList.remove('hidden');
				if (!window.isNewsletterModalShow) {
					modalEl && modalEl.show();
					window.isNewsletterModalShow = true;
				}
			}

			const alertEl = this.querySelector('.form-message--main');
			if (alertEl) {
				if (!window.isNewsletterModalShow) {
					modalEl && modalEl.show();
					window.isNewsletterModalShow = true;
				}
			}
		}
	}
	customElements.define('newsletter-form', NewsletterForm, { extends: 'form' });
}